import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BellActive = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 6C13.6569 6 15 4.65685 15 3C15 1.34315 13.6569 0 12 0C10.3431 0 9 1.34315 9 3C9 4.65685 10.3431 6 12 6ZM12.5833 9V6.95777C12.3929 6.98559 12.1981 7 12 7C11.8593 7 11.7203 6.99273 11.5833 6.97856V9C11.5833 9.36631 11.6112 9.86216 11.8184 10.3181C12.0386 10.8026 12.4475 11.2107 13.126 11.3944C13.2465 11.4271 13.3484 11.489 13.4143 11.559C13.477 11.6255 13.5 11.6896 13.5 11.75C13.5 11.8881 13.3881 12 13.25 12H10.5H10H6H5.5H2.75C2.61193 12 2.5 11.8881 2.5 11.75C2.5 11.6412 2.60362 11.4687 2.86939 11.3998C3.54382 11.2251 3.95739 10.8324 4.1809 10.3457C4.38966 9.89108 4.41667 9.3882 4.41667 9V6C4.41667 4.85093 4.76062 3.99149 5.34253 3.41889C5.9254 2.84533 6.80759 2.5 8 2.5L8.03094 2.50008C8.07422 2.15294 8.16198 1.81961 8.28834 1.50598C8.19337 1.50199 8.09724 1.5 8 1.5C6.61508 1.5 5.4556 1.90467 4.64114 2.70611C3.82571 3.50851 3.41667 4.64907 3.41667 6V9C3.41667 9.36314 3.3856 9.68129 3.27214 9.92834C3.17345 10.1433 3.00067 10.3328 2.61856 10.4318C2.08239 10.5707 1.5 11.0303 1.5 11.75C1.5 12.4404 2.05964 13 2.75 13H5.54018C5.6478 13.6429 5.96313 14.1243 6.38267 14.4527C6.8852 14.846 7.50072 14.9929 8 14.9929C8.49928 14.9929 9.1148 14.846 9.61733 14.4527C10.0369 14.1243 10.3522 13.6429 10.4598 13H13.25C13.9404 13 14.5 12.4404 14.5 11.75C14.5 11.03 13.9169 10.5726 13.3874 10.4292C13.0087 10.3266 12.8309 10.129 12.7288 9.90429C12.6136 9.65097 12.5833 9.33405 12.5833 9ZM6.56267 13C6.64851 13.31 6.81335 13.5199 6.99906 13.6652C7.29044 13.8933 7.67492 13.9929 8 13.9929C8.32508 13.9929 8.70956 13.8933 9.00094 13.6652C9.18665 13.5199 9.35149 13.31 9.43733 13H6.56267Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default BellActive
